/* global Hls */
export const hlsOptions = {
  capLevelToPlayerSize: true,
  startLevel: 5
};

export const hlsPlayers = {};

/**
 * Create a new Hls instance, tearing down any existing
 * player of the same type
 *
 * @param {string} type Hls player type
 * @param {HTMLVideoElement} element Video
 * @param {string} src Video src
 * @returns {object} Hls.js instance
 */
export function createHlsPlayer(type, element, src) {
  let player = hlsPlayers[type];
  if (player) {
    player.detachMedia();
    player.destroy();
  }
  player = hlsPlayers[type] = new Hls(hlsOptions);
  player.attachMedia(element);
  player.loadSource(src);
  return player;
}
